// Colors for achievement tracks. A track with an accent (a one-milestone theme,
// e.g. Twitch) uses its accent's Tailwind family. Otherwise level N (the Nth
// milestone) has one family, from cool to hot. A track has at most 10
// milestones, so every level has a color. The palette is set as CSS variables,
// so the card's classes stay static: e.g. `bg-(--lvl-500)`.

import type { CSSProperties } from 'react';
import type { AchievementAccent } from '@airhead-games/shared/types';
import {
  getColorStop,
  type ColorStop,
  type PlayerColorFamily,
} from '@/styles/playerColors';

const ACCENT_FAMILIES: Record<AchievementAccent, PlayerColorFamily> = {
  twitch: 'purple', // matches the Twitch button (bg-purple-400)
};

const LEVEL_FAMILIES: PlayerColorFamily[] = [
  'pink',
  'purple',
  'indigo',
  'blue',
  'sky',
  'teal',
  'green',
  'yellow',
  'orange',
  'red',
];

const PALETTE_STOPS: ColorStop[] = [
  '50',
  '100',
  '200',
  '500',
  '600',
  '800',
  '900',
  '950',
];

/** CSS variables `--lvl-<stop>` for the track's accent, else a 1-based level. */
export const trackPaletteStyle = (
  accent: AchievementAccent | null,
  level: number
): CSSProperties => {
  const family = accent ? ACCENT_FAMILIES[accent] : LEVEL_FAMILIES[level - 1];
  return Object.fromEntries(
    PALETTE_STOPS.map((stop) => [`--lvl-${stop}`, getColorStop(family, stop)])
  );
};
